import Request from "../config/Request";
export function NotiCountByCompany(data){
  return Request({
    url: "/Noti/NotiCountByCompany",
    method: "POST",
    data: data,
  })
}